function addMetaRobots (robots, headMarkup) 
{   
    const activeEnv = process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || 'local';
    const content = [];
    const myObject = typeof robots === 'string' ? JSON.parse(robots) : {};

    if (activeEnv === 'production')
    {
        Object.values(myObject).forEach((value) => 
        {
            content.push(value);
        });
    
        return `${headMarkup} <meta name="robots" content="${content.join(', ')}">`;
    }
    
    return `${headMarkup} <meta name="robots" content="noindex">`;
}

export default addMetaRobots;